import React from 'react';

import { PrimaryButton, ProButton } from '@components/Button/variants';
import IconClose from '@components/Images/Rebranding/IconClose';

import MobileStepDots from './MobileStepDots';

export interface MobileStepWithMediaProps {
  /** When provided, renders instead of title + description below the media. */
  contentBelowMedia?: React.ReactNode;
  description?: string;
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  media: React.ReactNode;
  showCloseButton?: boolean;
  step: number;
  title?: string;
  totalSteps: number;
}

const MobileStepWithMedia = ({
  contentBelowMedia,
  description,
  handleClose,
  handleNext,
  isProSubscriber,
  media,
  showCloseButton = true,
  step,
  title,
  totalSteps,
}: MobileStepWithMediaProps) => {
  const Button = isProSubscriber ? ProButton : PrimaryButton;
  const hasCustomContent = contentBelowMedia != null;

  return (
    <div
      id="mobile-step-tooltip"
      className="relative flex min-h-[calc(100vh-252px)] w-[360px] max-w-[calc(100vw-32px)] flex-col bg-grayscale-charcoal px-20 pb-16 pt-48"
    >
      {showCloseButton && (
        <button
          type="button"
          className="absolute right-16 top-16 cursor-pointer touch-manipulation border-none bg-transparent p-0"
          onClick={handleClose}
          aria-label="Close"
        >
          <IconClose className="stroke-2 text-white" height={26} width={26} />
        </button>
      )}
      <div className="flex flex-1 flex-col">
        <div className="h-[305px] w-full shrink-0 overflow-hidden rounded-[0]">{media}</div>
        <div className="mt-16 flex flex-col gap-4">
          {hasCustomContent ? (
            contentBelowMedia
          ) : (
            <>
              {title != null && (
                <h2 className="my-0 font-suisse-screen text-headline-alt-sm font-medium text-white">
                  {title}
                </h2>
              )}
              {description != null && (
                <p className="my-0 font-suisse-screen text-disclosure-lg text-white">
                  {description}
                </p>
              )}
            </>
          )}
        </div>
        <div className="mt-auto flex flex-col items-center gap-16 pt-16">
          <Button as="button" size="small" className="w-full" onClick={handleNext}>
            Next
          </Button>
          <MobileStepDots step={step} totalSteps={totalSteps} />
        </div>
      </div>
    </div>
  );
};

export default MobileStepWithMedia;
